import React, { Component } from "react";

import { Wrapper, Title, Copy, Button } from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import { openUrl } from "app/NativeActions";

class IOSText extends Component {
  render() {
    if (this.props.platform === "ios") {
      return (
        <Wrapper
          style={{
            alignItems: !this.props.center ? "flex-start" : "center",
            justifyContent: !this.props.center ? "flex-start" : "center",
            marginBottom: 10
          }}
        >
          <Wrapper
            style={{
              alignItems: !this.props.center ? "flex-start" : "center",
              justifyContent: !this.props.center ? "flex-start" : "center",
              marginBottom: 10
            }}
          >
            <Title
              style={{ textAlign: !this.props.center ? "left" : "center" }}
            >
              {this.props.onboarding_info.iosTitle}
            </Title>
            <Copy style={{ textAlign: !this.props.center ? "left" : "center" }}>
              {this.props.onboarding_info.iosText}
            </Copy>
          </Wrapper>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}
export default IOSText;
